import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { Table } from 'primeng/table';
import { FormGroup, NgForm } from '@angular/forms';
import { OrcamentoService } from 'src/app/admihair/service/orcamento.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { Paginador } from 'src/app/admihair/api/dto/paginacao/paginador';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ItemServicoService } from 'src/app/admihair/service/item-servico.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { ItemServico } from 'src/app/admihair/api/dto/item-servico';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { ItemOrcamento } from 'src/app/admihair/api/dto/item-orcamento';
import { Orcamento } from 'src/app/admihair/api/dto/orcamento';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';

@Component({
  selector: 'app-orcamentos-e-pacotes-inserir',
  templateUrl: './orcamentos-e-pacotes-inserir.component.html',
  styleUrls: ['./orcamentos-e-pacotes-inserir.component.scss']
})
export class OrcamentosEPacotesInserirComponent extends AdmihairBaseComponent implements OnInit {

  orcamento: Orcamento = {};
  progressoRequisicao: boolean = false;
  exibirDialogItem: boolean = false;
  exibirSpinnerDialogItem: boolean = false;
  listaItensDialog: any[] = [];
  loadingItensDialog: boolean = false;

  exibirDialogCliente: boolean = false;
  exibirSpinnerDialogCliente: boolean = false;
  listaClientes: Cliente[] = [];

  exibirDialogCadastroCliente: boolean = false;
  requisicaoCadastroCliente: boolean = false;

  loadingTable: boolean = false;
  loadingClientes: boolean = false;
  itensClientesPaginados?: Paginador<Cliente>;
  numeroPaginaCliente: number = 0;
  inputBusca?: string = '';

  clienteSelecionado?: Cliente;
  nomeClienteSelecionado: string = '';

  listaItensOrcamento: ItemOrcamento[] = [];
  tipoItemSelecionado: number = 4;
  tiposOrcamento: SelectItem[] = [
    {label: 'ORÇAMENTO', value: 'ORCAMENTO'},
    {label: 'PACOTE', value: 'PACOTE'}
  ];
  tipoOrcamentoSelecionado: string = 'ORCAMENTO';
  tiposItem: SelectItem[] = [{ label: 'Serviço', value: 4 }, { label: 'Produto', value: 3 }];
  valorTotalItens: number = 0;

  valorProposta: number = 0;
  valorDescontoTotal: number = 0;

  exibirRedirecionarCliente: boolean = false;

  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;

  constructor(private clienteService: ClienteService,
    private itemProdutoService: ItemProdutoService,
    private itemServicoService: ItemServicoService,
    private orcamentoService: OrcamentoService,
    private contatoClienteService: ContatoClienteService,
    private confirmationService: ConfirmationService,
    router: Router,
    activatedRoute: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) {
    super(erroService, storageService, router, activatedRoute)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ORCAMENTOS_E_PACOTES');
  }

  salvar() {
    this.progressoRequisicao = true;
    this.orcamento.tipo = this.tipoOrcamentoSelecionado;
    this.orcamento.interessado = this.clienteSelecionado;
    this.orcamento.valorProposta = this.valorProposta;
    this.orcamento.desconto = this.valorDescontoTotal;
    this.orcamento.listaItens = this.listaItensOrcamento;
    this.orcamento.empresaId = this.getEmpresa().id;

    this.orcamentoService.salvar(this.orcamento).subscribe({
      next: (data: Orcamento) => {
        this.progressoRequisicao = false;
        this.exibirMensagemSucesso();
        this.limparFormulario();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  onPageChangeCliente(event: any) {
    this.loadingTable = true;
    if (this.itensClientesPaginados) {
      this.numeroPaginaCliente = (event.first + event.rows) / this.itensClientesPaginados.size;
    }
    this.carregarClientes(this.numeroPaginaCliente - 1);
  }
  

  carregarClientes(numPagina: number) {
    const status = true;
    const ordernacao = 'nome,asc';
    const tamanhoPagina = 5;
    this.clienteService.listarClientesPorEmpresaESituacaoETextoBuscaPaginado(this.getEmpresa().id, status,
      numPagina, tamanhoPagina, ordernacao, this.inputBusca).subscribe({
        next: (data: Paginador<Cliente>) => {
          this.itensClientesPaginados = data;
          this.listaClientes = data.content;
          this.loadingTable = false;
          this.exibirSpinnerDialogCliente = false;
        },
        error: (err: any) => {
          this.loadingTable = false;
          this.exibirSpinnerDialogCliente = false;
          this.exibirMensagemErro(err)
        }
      });


  }
  abrirConfirmationDialogCpfCliente(){
    this.confirmationService.confirm({
      message: 'CPF obrigatório. Deseja atualizar agora?',
      header: 'Atenção',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      acceptIcon: 'pi pi-check',
      rejectLabel: 'Não',
      rejectIcon: 'pi pi-times',
      accept: () => {
        this.redirecionarClienteSemCpf();
      }
  });

  }

  selecionarCliente(cliente: Cliente) {
      this.clienteSelecionado = cliente;
      this.nomeClienteSelecionado = cliente.nome ?? '';
      this.exibirDialogCliente = false;
      this.verificarClienteSemCpf();
  }

  verificarClienteSemCpf(){
    if(this.clienteSelecionado && this.tipoOrcamentoSelecionado === 'PACOTE' &&
       !this.clienteSelecionado.cpf) {
        this.abrirConfirmationDialogCpfCliente()
       }
  }


  redirecionarClienteSemCpf() {
    this.redirecionarPaginaGeral(`apps/cliente/editar/${this.clienteSelecionado?.id}`)
  }


  buscarDialogCliente(event: Event) {
    this.loadingTable = true;
    this.inputBusca = (event.target as HTMLInputElement).value;
    this.carregarClientes(0);
  }

  limparDialogCliente() {
    this.loadingTable = true;
    this.filter.nativeElement.value = '';
    this.inputBusca = '';
    this.carregarClientes(0);
  }

  abrirDialogCliente() {
    this.exibirSpinnerDialogCliente = true;
    this.exibirDialogCliente = true;
    this.limparDialogCliente();
  }

  fecharDialogCliente() {
    this.exibirDialogCliente = false;
  }

  abrirDialogCadastroCliente() {
    this.exibirDialogCliente = false;
    this.exibirDialogCadastroCliente = true;
  }

  fecharDialogCadastroCliente() {
    this.exibirDialogCadastroCliente = false;
  }

  fomatarAniversarioCliente(aniversario?: string): Date | undefined {
    if(aniversario !== '' && aniversario !== undefined){
      const [day, month] = aniversario?.split('/');
      const dataFormatada = new Date(new Date().getFullYear(), Number(month) - 1, Number(day));
      return new Date(dataFormatada);
    }
    return undefined;
  }

  cadastrarCliente(formUsuario: FormGroup) {
    this.requisicaoCadastroCliente = true;
    let novoCliente: Cliente = {
      nome: formUsuario.value.nome,
      apelido: formUsuario.value.apelido,
      cpf: formUsuario.value.cpf,
      aniversario: this.fomatarAniversarioCliente(formUsuario.value.aniversario),
      email: formUsuario.value.email,
      empresa: this.getEmpresa()
    }

    this.clienteService.salvar(novoCliente).subscribe({
      next: (data: Cliente) => {
        this.salvarContatoCliente(data, formUsuario.value.telefone)
      },
      error: (err: any) => {
        this.requisicaoCadastroCliente = false;
        this.clienteSelecionado = undefined;
        this.nomeClienteSelecionado = '';
        this.exibirDialogCadastroCliente = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  salvarContatoCliente(cliente: Cliente, telefone: string) {
    const contatoCliente: ContatoCliente = {
      cliente: cliente,
      identificacao: 'PESSOAL',
      numero: telefone,
      principal: true
    }
    this.contatoClienteService.salvar(contatoCliente).subscribe({
      next: (data: ContatoCliente) => {
        this.requisicaoCadastroCliente = false;
        this.clienteSelecionado = cliente;
        this.nomeClienteSelecionado = cliente.nome ?? '';
        this.exibirDialogCadastroCliente = false;
      },
      error: (err: any) => {
        this.requisicaoCadastroCliente = false;
        this.clienteSelecionado = undefined;
        this.nomeClienteSelecionado = '';
        this.exibirDialogCadastroCliente = false;
        this.exibirMensagemErro(err);
      }
    })
  }


  abrirDialogItem() {
    this.exibirDialogItem = true;
    this.exibirSpinnerDialogItem = true;
    if(this.tipoOrcamentoSelecionado === 'PACOTE') {
      this.tipoItemSelecionado = 4;
    }
    this.carregarItens();
  }


  carregarItens() {
    this.loadingItensDialog = true;
    const status = true;
    const idEmpresa = this.getEmpresa().id;
    if (this.tipoItemSelecionado === 4) {
      this.itemServicoService.listarPorEmpresaIdESituacao(idEmpresa, status).subscribe({
        next: (data: ItemServico[]) => {
          this.listaItensDialog = data.filter(itemServico =>
            !this.listaItensOrcamento.some(itemOrcamento =>
              itemOrcamento.itemId === itemServico.id)
            );
            this.exibirSpinnerDialogItem = false;
            this.loadingItensDialog = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialogItem = false;
          this.exibirMensagemErro(err);
        }
      });
    } else if (this.tipoItemSelecionado === 3) {
      this.itemProdutoService.listarProdutoVendaPorEmpresaId(idEmpresa).subscribe({
        next: (data: ItemProduto[]) => {
          this.listaItensDialog = data.filter(itemProduto =>

            !this.listaItensOrcamento.some(itemOrcamento =>
              itemOrcamento.itemId === itemProduto.id)
            );
          this.exibirSpinnerDialogItem = false;
          this.loadingItensDialog = false;
        },
        error: (err: any) => {
          this.exibirSpinnerDialogItem = false;
          this.loadingItensDialog = false;
          this.exibirMensagemErro(err);
        }
      });
    }
  }


  adicionarItem(item: any) {
    this.listaItensOrcamento.push({
      itemId: item.id,
      nomeItem: item.descricao,
      quantidadeProposta: 1,
      quantidadeEntregue: 0,
      valorUnitario: item.valorVenda,
      descontoItem: 0
    });
    this.exibirDialogItem = false;
    this.calcularValorTotal();
  }

  calcularValorTotal() {
    this.valorTotalItens = 0;
    for(let item of this.listaItensOrcamento) {
      this.valorTotalItens = this.valorTotalItens + this.calcularValorTotalItem(item);
    }
    this.calcularValorProposta();
  }

  calcularValorTotalItem(item: ItemOrcamento): number {
    const desconto = item.descontoItem ?? 0;
    const quantidade = item.quantidadeProposta ?? 1;
    const valorUnitario = item.valorUnitario ?? 0;

    const valorComDesconto = valorUnitario - (valorUnitario * (desconto / 100));
    return valorComDesconto * quantidade;
  }

  calcularValorProposta(){
    this.valorProposta = 0;
    const descontoAplicado = (this.valorDescontoTotal ?? 0) / 100;
    this.valorProposta += this.valorTotalItens - (this.valorTotalItens * descontoAplicado);
  } 

  removerItemOrcamento(index: number) {
    this.listaItensOrcamento.splice(index, 1);
    this.calcularValorTotal();
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario(){
    this.form?.reset();
    this.clienteSelecionado = undefined;
    this.nomeClienteSelecionado = '';
    this.listaItensOrcamento = [];
    this.valorProposta = 0;
    this.valorDescontoTotal = 0;
  }

  

}
